import { Col, ConfigProvider, Form, Input, Row } from "antd";
import cx from "classnames";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Input.module.css";

const FormInputIdentification = ({
    label = "",
    name = "",
    placeholder = null,
    type = "text",
    size = "middle",
    onChange = () => { },
    className = "",
    subclassName = "",
    required = false,
    disabled = false,
    autoSize = false,
    rows = 8,
    autoComplete = "off",
    vertical = true,
    fontWeight = "",
    labelFontSize = "16px",
    suffixMessage = null,
    maxLength = null,
    width = "100%",
    formItemLayout = {},
    numberOnly = false,
    variant = "outlined", //["outlined", "borderless", "filled"]
    rules = null,
    defaultValue = null,
    form = {}
}) => {

    const [inputValue, setInputValue] = useState('');
    const handleChange = (e, setFieldValue) => {
        const rawInput = e.target.value.replace(/\D/g, '');
        let formatted = '';


        for (let i = 0; i < rawInput.length && i < 13; i++) {
            if (i === 1 || i === 5 || i === 10 || i === 12) {
                formatted += '-';
            }
            formatted += rawInput[i];
        }
        setInputValue(formatted);
        form.setFieldsValue({ [name]: formatted });
        if (onChange) onChange(formatted, e);
    };

    const { t, i18n } = useTranslation();

    const layout = {
        labelCol: {
            span: 24,
        },
        wrapperCol: {
            span: 24,
        }
    }
    return (
        <ConfigProvider theme={{
            components: {
                Form: {
                    labelFontSize: labelFontSize
                },
            },
        }}>
            <Row direction="horizontal">
                <Col span={suffixMessage ? 5 : 24}>
                    <Form.Item shouldUpdate={() => false}>
                        {({ getFieldValue, setFieldValue }) =>
                            <Form.Item
                                {...(vertical && layout)}
                                labelAlign="left"
                                label={label}
                                name={name}
                                required={required}
                                style={{
                                    fontWeight: fontWeight,
                                    padding: "0px",
                                    margin: "0px"
                                }}
                                rules={rules ? [...rules, { required: required, message: i18n.language == 'th' ? 'กรุณากรอก ${label}' : '${label} is required' }] : [{ required: required, message: i18n.language == 'th' ? 'กรุณากรอก ${label}' : '${label} is required' }]}
                                {...formItemLayout}
                            >
                                {type === "text" || type === 'otp' || type === "password" ? (
                                    <Input
                                        style={{
                                            width,
                                        }}
                                        variant={variant}
                                        maxLength={maxLength}
                                        id={name}
                                        className={cx(styles.input, subclassName)}
                                        name={name}
                                        placeholder={placeholder ?? label}
                                        type={type}
                                        onFocus={(e) => {
                                            console.log("onFocus", e);
                                        }}
                                        onKeyDown={(e) => {
                                            if (numberOnly) {
                                                if (!e.key.match(/^[0-9]$/) && e.key !== 'Backspace' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') {
                                                    e.preventDefault();
                                                }
                                            }
                                        }}
                                        onChange={handleChange}
                                        disabled={disabled}
                                        size={size}
                                        autoComplete={autoComplete}
                                    />
                                ) : (
                                    <Input.TextArea
                                        rows={rows}
                                        autoSize={autoSize}
                                        id={name}
                                        className={cx(styles.input, subclassName)}
                                        name={name}
                                        placeholder={placeholder ?? label}
                                        type={type}
                                        onChange={handleChange}
                                        disabled={disabled}
                                        size={size}
                                        autoComplete={autoComplete}
                                    />
                                )}
                            </Form.Item>
                        }
                    </Form.Item>
                    <Col flex={"auto"} style={{ alignContent: "center" }}>
                        {suffixMessage && (
                            <span>{suffixMessage}</span>
                        )}
                    </Col>
                </Col>

            </Row>

        </ConfigProvider >
    );
};

export default FormInputIdentification;
